export default __webpack_public_path__ + "static/slider-ks-bfb6828a02fb6b780544c84c235920e0.avif";